import styled, { css } from 'styled-components'
import theme from 'common/style/styleSetup'
// import bgImg from 'assets/images/Main_BG.png'
import bgImg from 'assets/images/Layer-bg.png'
//  background-image: url(${bgImg});
// import small_banner from 'assets/images/_appointment/small_banner.png'

export const Wraper = styled.div<{ active?: any }>`
  width: 100%;
  height: 100%;
  min-height: 100vh;
  min-width: 100vw;
  background-color: ${theme.bg[23]};

  // background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  position: relative;

  @media screen and (max-width: 1250px) {
    padding: 0px 0px 0px 0px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(0, 0, 0, 0.5); */
    z-index: 1;
  }
`
export const Container = styled.div<{ active?: any }>`
  width: 100%;
  margin-top: 4px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  position: relative;
  flex-direction: column;
`
export const InForCompany = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 100px;
  background-color: transparent;
  z-index: 10;
`
export const InforCompanyChiren = styled.div`
  width: 64%;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 768px) {
    gap: 20px;
    width: 85%;
    flex-wrap: wrap;
  }
`
export const LeftMenu = styled.div`
  width: 260px;
  height: auto;
  max-height: -webkit-fill-available;
  position: absolute;
  /* max-height: calc(100vh - 110px); */
  top: 0;

  left: 12px;
  background: red;
  background: ${theme.bg[18]};
  padding: 5px 5px 15px;
  overflow: auto;
`

export const Children = styled.div`
  /* width: calc(100% - 580px); */
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: transparent;
  /* background-color: brown; */
  /* margin: 0 auto; */
  // height: calc(100vh - 110px);
  // overflow: auto;
  z-index: 10;
  /* @media screen and (max-width: 768px) {
    width: calc(100% - 40px);
  } */
  /* position: ; */
`

export const RightMenu = styled.div`
  width: 260px;
  height: auto;
  position: absolute;
  top: 0;
  right: 12px;
  max-height: -webkit-fill-available;
  overflow: auto;
`
export const footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  background-color: transparent;
  z-index: 10;
`
export const footerChiren = styled.div`
  width: 64%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`
export const footerImage = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
  }
`
